module.exports = __webpack_public_path__ + "img/upload.a1ba0276.svg";